import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconIronMapS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.32258 3.2L2 6.8L3.16129 12L7 14L12 12.5L14 9L12.8387 4L8.96774 2L4.32258 3.2Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02797 1.46814L13.2739 3.66185L14.5318 9.07786L12.3354 12.9215L6.9495 14.5373L2.72438 12.336L1.4668 6.70478L4.00873 2.76478L9.02797 1.46814ZM2.81604 6.45804L5.31221 5.03166L9.43884 4L11.7498 4L8.90828 2.53189L4.63719 3.63525L2.81604 6.45804ZM12.558 5L9.56194 5L5.68857 5.96834L2.70741 7.67187L3.4837 11.1479L6.31221 9.53166L10.4388 8.5L13.3709 8.5L12.558 5ZM7.05127 13.4627L4.12053 11.9358L6.68857 10.4683L10.5619 9.5H13.1388L11.6654 12.0785L7.05127 13.4627Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}

export const IconIronMap = createIcon({
  l: IconIronMapS,
  m: IconIronMapS,
  s: IconIronMapS,
  xs: IconIronMapS,
  name: 'IconIronMap',
})
